export const apiError = (error, fallback) => {
  const data = error?.response?.data;
  if (data?.errors) {
    const first = Object.values(data.errors)[0];
    if (Array.isArray(first) && first[0]) return first[0];
  }
  return data?.message || fallback;
};

/** Accent presets that read well on both the light and dark menu themes. */
export const ACCENTS = ['#1a4be0', '#0f6b5c', '#2f6b2a', '#8a5a00', '#b0122b', '#7a2e8e', '#c2185b', '#111111'];

export const TAGS = ['popular', 'new', 'chef', 'spicy', 'vegetarian', 'vegan', 'gluten_free'];

export const formatPrice = (symbol, value) => {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  return symbol + (Number.isInteger(n) ? n.toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
};

/** Lowest price, from the options when the dish has sizes. */
export const startingPrice = (item) => {
  const options = (item.price_options || []).map((o) => Number(o.price)).filter((n) => !Number.isNaN(n));
  if (options.length) return Math.min(...options);
  return item.price === null || item.price === undefined ? null : Number(item.price);
};
